<div *ngIf="statistic" class="row">
    <div class="col-3">
        <div class="border p-3">
            <h5 class="h6 fw-bold card-title text-muted mb-0">Total Employee</h5>
            <p class="h1 fw-bold mb-0">{{statistic.total }}</p>
        </div>
    </div>
    <div class="col-3">
        <div class="border p-3">
            <h5 class="h6 fw-bold card-title text-muted mb-0">Total Locked</h5>
            <p class="h1 fw-bold mb-0">{{statistic.locked }}</p>
        </div>
    </div>
    <div class="col-3">
        <div class="border p-3">
            <h5 class="h6 fw-bold card-title text-muted mb-0">Transfer Request Approved</h5>
            <p class="h1 fw-bold mb-0">{{statistic.approved }}</p>
        </div>
    </div>
    <div class="col-3">
        <div class="border p-3">
            <h5 class="h6 fw-bold card-title text-muted mb-0">Transfer Request Rejected</h5>
            <p class="h1 fw-bold mb-0">{{statistic.rejected }}</p>
        </div>
    </div>
</div>